import { MFChannel } from '../../../Components/SDK';
import { setTotalRecords } from '../../../slice';
import { Store } from '../../../store';

export const fetchInvitationCount = async () => {
    try {
        const response = await MFChannel.fetchChannelInvitationList({
            createdAt: 0,
            size: 1,
        });
        const pendingRecords = response?.data?.pendingRecords || 0;
        Store.dispatch(setTotalRecords(pendingRecords));
        return pendingRecords;
    } catch (error) {
        return;
    }
};

export const handleIconTabUnreadChannel = async () => {
    fetchInvitationCount();
};
